import React from 'react'

const WorkItemPopup = ({ item, title }) => {
  const stackStyle = { "marginTop": ".5rem", "border": "1px solid rgb(53, 0, 132)", "color": "rgb(53, 0, 132)", "fontSize": "small", "fontWeight": "500", "padding": "0.2rem", "borderRadius": "0.9rem", "marginRight": "5px" }
  return (
    <div id={item.content.id} className="popup-box mfp-fade mfp-hide">
      <div className="content">
        <div className="image">
          <img src={item.content.image} alt="" />
        </div>
        <div className="desc">
          <div className="post-box">
            <h1 style={{ margin: '0' }}>{item.description.name}</h1>
            <div style={{ margin: '0' }} className="blog-detail">{item.content.detail}</div>
            <div style={{ marginBottom: '1rem' }} className="blog-content">
              <p>{item.content.description}</p>
            </div>
            <div >
              <h5 style={{ margin: '0' }}>{title.functionalityTitle}</h5>
              <ul style={{
                padding: '0.6rem',
                lineHeight: '1.8rem'
              }} className="list">
                {item.content.functionalities.map((fonctionnality, i) => (
                  <li key={`func-${i}`}><i className="fas fa-check"></i> {fonctionnality}</li>
                ))}
              </ul>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <h5 style={{ margin: '0' }}>{title.stackTitle}</h5>
              <div style={{ "display": "flex", "flexWrap": "wrap" }}>
                {item.content.stack.map((stack, i) => (
                  <span style={stackStyle} key={`stack-${i}`}>{stack}</span>
                ))}
              </div>

            </div>
            {item.content.button && (
              <a target='_blank' rel='noopener noreferrer' href={item.content.button.link} className="button">
                <span className="text">{item.content.button.text}</span>
                <span className="arrow"></span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div >
  )
}

export default WorkItemPopup